export default __webpack_public_path__ + "static/media/IMG-20240729-WA0016.7a94cc4b.jpg";